import React from 'react';

import {
  Grid2 as Grid,
  Grid2Props,
  styled,
  SxProps,
  Theme,
} from '@mui/material';

export type ResponsiveGridProps = React.PropsWithChildren<
  {
    sx?: SxProps<Theme>;
    id?: string;
    className?: string;
    gridProps?: React.ComponentProps<typeof Grid>;
  } & React.HTMLAttributes<HTMLDivElement>
>;

export const ResponsiveGrid = ({
  id,
  children,
  sx,
  className,
  gridProps,
  ...rest
}: ResponsiveGridProps) => (
  <GridWrapper id={id} sx={sx} className={className} {...rest}>
    <GridContainer {...gridProps}>{children}</GridContainer>
  </GridWrapper>
);

export default ResponsiveGrid;

export const GridContainer = (gridProps: Grid2Props) => (
  <StyledGrid container rowSpacing={0} {...gridProps} />
);

export const StyledGrid = styled(Grid)(({ theme }) => ({
  // use this styles for a maximal width with centered alignment
  // maxWidth: 'calc(1920px - calc(2 * var(--margin)))',
  // [theme.breakpoints.up('lg')]: {
  //   margin: '0 auto',
  // },
}));

export const GridWrapper = styled('div')({
  paddingLeft: 'var(--margin)',
  paddingRight: 'var(--margin)',
  boxSizing: 'border-box',
  transition:
    'padding var(--transition-duration) var(--transition-timing-cubic-bezier)',
});
